import styled from 'styled-components';
import { S } from './NewSingUp.style';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginSerivce from '../../service/login/login';
import PageTop, { MainPageTop } from '../components/pageTop/PageTop';
// import TopBanner from '../NewMain/components/TopBanner';

const NewSignUp = () => {
  const [tab, setTab] = useState('personal');

  const handelTab = (tab: string) => {
    setTab(tab);
  };
  const SocialLoginApi = (type: string) => {
    LoginSerivce.socialLogin(type, window.location.origin);
  };

  const navigate = useNavigate();
  return (
    <S.Wrapper>
      <div
        style={{
          padding: '16px',
        }}
      >
        <img
          onClick={() => {
            navigate(-1);
          }}
          src="/assets/images/arrow/back-arrow-left-gray.svg"
        ></img>
      </div>
      <S.Container>
        <S.Inner>
          <TitleBox>
            <div style={{ fontSize: '20px', fontWeight: '700', color: '#222' }}>
              회원가입
            </div>
            <div>
              <div>손쉽게 시작하는 현명한 투자</div>
              <div>지금 땅집고옥션에서 시작하세요.</div>
            </div>
          </TitleBox>
          <S.SignUpBox>
            <S.EmailBox
              onClick={() => {
                navigate('/signupForm');
              }}
            >
              {'이메일로 시작하기'}
            </S.EmailBox>
            <S.SocialLogin>
              <S.LineBox>
                <S.Line></S.Line>
                <span>소셜 계정으로 간편하게 시작하기</span>
                <S.Line></S.Line>
              </S.LineBox>
              <S.LogoBox>
                <S.Img
                  src="/assets/images/logo/btn_kakao_login.svg"
                  alt=""
                  onClick={() => {
                    SocialLoginApi('kakao');
                    localStorage.setItem('socialLoginType', 'K');
                  }}
                />
                <S.Img
                  src="/assets/images/logo/btn_naver_login.svg"
                  alt=""
                  onClick={() => {
                    SocialLoginApi('naver');
                    localStorage.setItem('socialLoginType', 'N');
                  }}
                />
                <S.Img
                  src="/assets/images/logo/btn_google_login.svg"
                  alt=""
                  onClick={() => {
                    // RedirectHandler('Google');
                    SocialLoginApi('google');
                    localStorage.setItem('socialLoginType', 'G');
                  }}
                />
              </S.LogoBox>
            </S.SocialLogin>
          </S.SignUpBox>
        </S.Inner>
      </S.Container>
    </S.Wrapper>
  );
};

export default NewSignUp;

const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: #616161;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 23.2px;
  word-wrap: break-word;
  text-align: center;
  img {
    width: 112px;
    height: 60px;
  }
`;
